module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"Where In The World","short_name":"WITW","start_url":"/","background_color":"#fff","theme_color":"#0096ff","display":"standalone","icon":"E:\\Code\\Works\\frontendmentor.io\\04 where-in-the-world/src/images/logo.png","theme_color_in_head":false,"legacy":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"ee87bb7ec310cb6f468d0d8cea28a15b"},
    },{
      plugin: require('../node_modules/gatsby/dist/internal-plugins/partytown/gatsby-browser.js'),
      options: {"plugins":[]},
    }]
